import { useMemo, useState, useEffect} from "react";
import { useGroupChatContext } from "../../context/groupchatContext";
import { useGetLocationChatsQuery } from "../../services/chatService";
import React from "react";
import ChatThreadListing from "./chatThreadListing";

export default function LocationChatThread(){

    const groupChatContext = useGroupChatContext();
    const {selectedLocations, chatFilter, selectedChatTab} = useMemo(() => ({
        selectedLocations: groupChatContext.selectedLocations,
        chatFilter: groupChatContext.chatFilter,
        selectedChatTab: groupChatContext.selectedChatTab
    }));

    const [pagination, setPagination] = useState({limit: 20, page: 1});
    const [chatApiParams, setChatApiParams] = useState({ location_id: selectedLocations, ...pagination, last_chat_id: '', unread_only: chatFilter.unread_only, urgent: chatFilter.urgent_only , unacknowledged: chatFilter.unacknowledged, mention: chatFilter.mention, attachment: chatFilter.attachment });

    const {
        data: locationChats, isFetching: locationChatsFetching
    } = useGetLocationChatsQuery({...chatApiParams}, {refetchOnMountOrArgChange: true});


    useEffect(()=>{
        let chatThreadsLength = locationChats?.data?.length;
        let lastChat = {}
        if(chatThreadsLength){
            lastChat = locationChats?.data[chatThreadsLength-1];
        }
        setChatApiParams({location_id: selectedLocations, ...pagination, last_chat_id: pagination.page == 1 ? '' : lastChat.chat_id, unread_only: chatFilter.unread_only, urgent: chatFilter.urgent_only, unacknowledged: chatFilter.unacknowledged, mention: chatFilter.mention, attachment: chatFilter.attachment})
    }, [pagination])

    useEffect(()=>{
        setPagination({...pagination, page: 1});
    }, [selectedLocations, chatFilter, selectedChatTab])


    const fetchMoreChats = () => {
        setPagination({...pagination, page: ++pagination.page})
    }

    return(
        <div>
            <ChatThreadListing chatThreadsData={locationChats} fetchMoreChats={fetchMoreChats} isLoadingData={locationChatsFetching} pagination={pagination} />
        </div>
    )
}

